﻿import * as d3 from "d3";
import { color, getFormat } from "./helpers";
import { redrawLinks } from "./links";

import { capitalize } from "./../../../Common/Helpers"

const nodeTransform = (d) => `translate(${d.x0}, ${d.y0})`;
const getNodeId = (d) => `node-${d.name.replace(/[^a-z0-9]/gi, "-")}`;

export let moveNodeTo;
const moveNodeToGenerator = (width, height) => {
    return (d, x, y) => {
        const dWidth = d.x1 - d.x0;
        const dHeidth = d.y1 - d.y0;
        const toX = Math.max(0, Math.min(width - dWidth, x));
        const toY = Math.max(0, Math.min(height - dHeidth, y));

        d.x0 = toX;
        d.x1 = toX + dWidth;
        d.y0 = toY;
        d.y1 = toY + dHeidth;

        d3.select(`#${getNodeId(d)}`).attr("transform", nodeTransform);

        redrawLinks();
    };
};

const getDragHandler = (e, d) => {
    moveNodeTo(d, e.x, e.y);
};

export const create = ({ container, data, units, width, height }) => {
    const format = getFormat(units);
    const wrapper = container.append("g").attr("stroke", "#000");
    moveNodeTo = moveNodeToGenerator(width, height);
    
    const node = wrapper
        .selectAll(".node")
        .data(data.nodes)
        .join("g")
        .attr("class", "node")
        .attr("id", getNodeId)
        .attr("transform", nodeTransform)
        //.call(
        //    d3
        //        .drag()
        //        .subject((e, d) => {
        //            return { x: d.x0, y: d.y0 };
        //        })
        //        .on("drag", getDragHandler)
        //);

    node
        .append("rect")
        .attr("height", (d) => d.y1 - d.y0)
        .attr("width", (d) => d.x1 - d.x0)
        .attr("fill", color)
        .append("title")
        .text((d) => `${d.name}\n${format(d.value)}`);

    const adjust = (year) => {
        return year == 5 ? -30 : 0;
    }
    // texts
    //node
    //    .append("text")
    //    .attr("x", (d) => (d.x0 < width / 2 ? d.x1 - d.x0 + 6 : -6))
    //    .attr("y", (d) => (d.y1 - d.y0) / 2 + adjust(d.name.slice(-1)))
    //    //.attr("dy", "0.35em")
    //    .attr("text-anchor", (d) => (d.x0 < width / 2 ? "start" : "end"))
    //    .classed("ecr_node", true)
    //    .text((d) => `${capitalize(d.name.slice(0, -2).replace("assistant","Assistant Professor"))}`);
    //node
    //    .append("text")
    //    .attr("x", (d) => (d.x1 - d.x0 + 6))
    //    .attr("y", (d) => ((d.y1 - d.y0) / 2) - 10)
    //    //.attr("dy", "0.35em")
    //    .attr("text-anchor", "start")
    //    .classed("ecr_node", true)
    //    .text((d) => { console.log(d); return `Data Year ${d.name.slice(-1)}` });
    node
        .append("text")
        .attr("x", (d) => (d.x1 - d.x0 + 6))
        .attr("y", (d) => ((d.y1 - d.y0) / 2))
        //.attr("dy", "0.35em")
        .attr("text-anchor", "start")
        .classed("ecr_node", true)
        .text((d) => {
            return (d.value > 0) ? `${format(d.value)}` : ""
        })


    return wrapper;
};
